import React, { createContext, useContext, useState, useEffect } from 'react';
import { settingsAPI } from '../services/api';

const SettingsContext = createContext({});

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState({
    app_name:      'EnergyOS ERP 360',
    company_name:  'EnergyOS',
    primary_color: '#1D6B4E',
    logo_url:      '',
    currency:      'EUR',
    language:      'en',
  });

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (!token) return;

    settingsAPI.all()
      .then(({ data }) => {
        const map = {};
        (data.data || []).forEach((s) => { map[s.setting_key] = s.setting_value; });
        setSettings((prev) => ({ ...prev, ...map }));

        // Apply primary colour to CSS variable
        if (map.primary_color) {
          document.documentElement.style.setProperty('--color-primary', map.primary_color);
        }
      })
      .catch(() => {});
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, setSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
